import {
  Component,
  HostListener,
  QueryList,
  ViewChildren,
} from '@angular/core';
import { MaincontainerComponent } from '../maincontainer/maincontainer.component';
import { Base } from '../common/base';
import { FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { CategoriesPortafolioModel } from '../../models/portafolio';
import { DragScrollComponent } from 'ngx-drag-scroll';
import { ScrollService } from '../../utils/scroll-service';
import { MatDialog } from '@angular/material/dialog';
import { PortafolioService } from '../../services/portafolio/portafolio.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { UserLoggedResponse, UserRolResponde } from '../../models/user';
import { AuthService } from '../../services/security/auth.service';
import { StorageService } from '../../utils/util.storage.service';
import { DownloadService } from '../../services/util/download.service';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import dataPoblacion from '../../../assets/data/productsPortafolioPoblacion.json';
import { TrackingService } from '../../services/app-track/tracking.service';
import { ChangeDetectorRef } from '@angular/core';

@Component({
  selector: 'app-portafolio',
  templateUrl: './portafolio.component.html',
  styleUrls: ['./portafolio.component.css'],
})
export class PortafolioComponent extends Base {
  @ViewChildren('nav', { read: DragScrollComponent })
  dsComponents!: QueryList<DragScrollComponent>;
  @ViewChildren('searchText') searchTextCmp!: any;

  public filtrosData: CategoriesPortafolioModel[] = [
    // se tiene que convertir en servicio alimentado por admin ova
    { id: 0, name: 'Inicio', show: false },
    { id: 1, name: 'Portafolio de soluciones', show: true },
    { id: 2, name: 'Mi población', show: true },
    { id: 3, name: 'Lo más compartido', show: true },
    { id: 4, name: 'Sugerencias Coomeva', show: true },
    { id: 5, name: 'Añadidos recientemente', show: true },
  ];

  originalDataList: Product[] = new Array<Product>();
  filterShowList: Product[] = new Array<Product>();
  isDetail: boolean = false;
  isSublevel: boolean = false;
  showFavorites: boolean = false;
  selectedFilter: number = 0;
  frmPortafolio: FormGroup = new FormGroup({});
  colsToShowInCategory: number = 2;
  isSublevelWithDescription: boolean = false;
  productSelectedData: Product = new Product();
  productSublevelsData: Product[] = [];
  detailRouteList: Product[] = [];
  searchText: string = '';
  loggedUser: UserLoggedResponse = new UserLoggedResponse();
  activeDrag: number = 9999;
  htmlContent!: SafeHtml;
  jsonDataPoblacion = dataPoblacion as Array<any>;
  logInfo: any;
  cedulaAsesor: any;
  nombreAsesor: any;
  currentSubmodule: any;

  constructor(
    private mainCmp: MaincontainerComponent,
    private scrollService: ScrollService,
    public router: Router,
    private spinner: NgxSpinnerService,
    private authService: AuthService,
    private matDialog: MatDialog,
    private sanitizer: DomSanitizer,
    private portafolioService: PortafolioService,
    private storageService: StorageService,
    private downloadService: DownloadService,
    private trackingService: TrackingService,
    private cdr: ChangeDetectorRef
  ) {
    super();
    this.onResize();
    this.getLoggedData();
  }

  @HostListener('window:resize', ['$event'])
  onResize() {
    const width = window.innerWidth;
    if (width > 1400) {
      this.isSublevelWithDescription
        ? (this.colsToShowInCategory = 3)
        : (this.colsToShowInCategory = 6);
    } else if (width > 1200) {
      this.isSublevelWithDescription
        ? (this.colsToShowInCategory = 2)
        : (this.colsToShowInCategory = 4);
    } else if (width > 600) {
      this.isSublevelWithDescription
        ? (this.colsToShowInCategory = 1)
        : (this.colsToShowInCategory = 2);
    } else {
      this.colsToShowInCategory = 1;
    }
  }

  async getLoggedData() {
    this.loggedUser = await this.authService.getAuthInfo();
    this.getPortafolioData();
  }

  async ngOnInit(): Promise<void> {
    this.logInfo = await this.authService.getAuthInfo();
    console.log('servicio auth documento', this.logInfo);
    const userCC = this.logInfo?.document;
    this.cedulaAsesor = userCC.split('.')[1].trim();
    console.log('PortafolioComponent: cedulaAsesor ->', this.cedulaAsesor);
    this.nombreAsesor = this.logInfo
      ? `${this.logInfo.nombre ?? ''} ${this.logInfo.primerApellido ?? ''} ${
          this.logInfo.segundoApellido ?? ''
        }`.trim()
      : 'N/A';
    console.log('PortafolioComponent: nombreAsesor ->', this.nombreAsesor);
  }

  ngAfterViewInit() {}

  //dragscroll controls
  moveLeft(index: number) {
    this.dsComponents.toArray()[index].moveLeft();
  }
  moveRight(index: number) {
    this.dsComponents.toArray()[index].moveRight();
  }
  showButtons(i: number) {
    this.activeDrag = i;
  }
  hideButtons() {
    this.activeDrag = 9999;
  }

  onSelectFilter(filterItem: any) {
    this.selectedFilter == filterItem.id
      ? (this.selectedFilter = 0)
      : (this.selectedFilter = filterItem.id);
    this.showFavorites ? (this.showFavorites = false) : null; //resetear favoritos
    //filtrar
    if (this.selectedFilter != 0) {
      this.mainCmp.setTitle(filterItem.name);
      this.searchText = '';
      if (this.selectedFilter == 1 || this.selectedFilter == 2) {
        this.backToCatalog(2);
      }
      this.filterMainData(filterItem, false, false, '');
    } else {
      this.backToCatalog(1);
    }
  }

  onSelecFavorite() {
    this.showFavorites = !this.showFavorites;
    this.mainCmp.setTitle('Mis Favoritos');
    this.selectedFilter = 0; //resetear filtros
    if (this.showFavorites) {
      this.searchText = '';
      this.filterMainData(null, true, false, '');
    } else {
      this.backToCatalog(1);
    }
  }

  onTextChange(newText: string): void {
    if (newText == '') {
      this.selectedFilter = 0;
      this.showFavorites = false;
      this.backToCatalog(1);
    }
  }

  filterByText() {
    let query = this.searchText;
    this.selectedFilter = 0;
    this.showFavorites = false;
    if (query) {
      this.filterMainData(null, false, true, query);
    }
  }

  filterMainData(
    filterItem: CategoriesPortafolioModel | null,
    filterByFavorite: boolean,
    filterByText: boolean,
    filterText: string
  ) {
    if (filterItem?.id == 1 || filterItem?.id == 2) {
      //FILTRO AL NIVEL 1 PADRE
      this.filterShowList = this.originalDataList.filter(
        (item) => item.category == filterItem.id
      );
    } else {
      let newItemFilter: Product = new Product();
      if (filterByFavorite) {
        newItemFilter.title = 'Mis Favoritos';
      } else if (filterByText) {
        newItemFilter.title = 'Filtrando por: ' + filterText;
      } else if (filterItem != null) {
        newItemFilter.title = filterItem.name;
      } else {
        newItemFilter.title = 'Filtro 404';
      }

      newItemFilter.level = true;
      newItemFilter.sublevel = [];

      this.originalDataList.forEach((mainItem) => {
        if (mainItem.level /*&& !mainItem.isHome*/) {
          //lo comentado es para que ignore items de tipo home
          mainItem.sublevel?.forEach((subItem) => {
            if (
              (subItem.sublevel !== null || Array.isArray(subItem.sublevel)) &&
              subItem.level
            ) {
              // para incluir a los hijos con hijos
              if (filterByText) {
                if (
                  subItem.title.toLowerCase().includes(filterText.toLowerCase())
                ) {
                  newItemFilter.sublevel?.push(subItem);
                }
              }
              subItem.sublevel.forEach((finalLevel: Product) => {
                if (filterByFavorite) {
                  if (finalLevel.isFavorite) {
                    newItemFilter.sublevel?.push(finalLevel);
                  }
                } else if (filterByText) {
                  if (
                    finalLevel.title
                      .toLowerCase()
                      .includes(filterText.toLowerCase())
                  ) {
                    newItemFilter.sublevel?.push(finalLevel);
                  }
                } else {
                  switch (this.selectedFilter) {
                    case 3: //compartidos
                      if (!finalLevel.isHome && finalLevel.sharedCount != 0)
                        newItemFilter.sublevel?.push(finalLevel);
                      break;
                    case 4: //sugeridos coomeva
                      if (
                        !finalLevel.isHome &&
                        finalLevel.isSuggested &&
                        finalLevel.creationDate != null
                      ) {
                        finalLevel.creationDateFormat = new Date(
                          finalLevel.creationDate
                        );
                        newItemFilter.sublevel?.push(finalLevel);
                      }
                      break;
                    case 5: //recientes
                      if (
                        !finalLevel.isHome &&
                        finalLevel.creationDate != null
                      ) {
                        finalLevel.creationDateFormat = new Date(
                          finalLevel.creationDate
                        );
                        newItemFilter.sublevel?.push(finalLevel);
                      }
                      break;
                    default:
                      break;
                  }
                }
              });
            } else {
              //recorre los items que no tengan hijos
              if (filterByFavorite) {
                if (subItem.isFavorite) {
                  newItemFilter.sublevel?.push(subItem);
                }
              } else if (filterByText) {
                if (
                  subItem.title.toLowerCase().includes(filterText.toLowerCase())
                ) {
                  newItemFilter.sublevel?.push(subItem);
                }
              } else {
                switch (this.selectedFilter) {
                  case 3: //compartidos
                    if (!subItem.isHome && subItem.sharedCount != 0)
                      newItemFilter.sublevel?.push(subItem);
                    break;
                  case 4: //sugeridos coomeva
                    if (
                      !subItem.isHome &&
                      subItem.isSuggested &&
                      subItem.creationDate != null
                    ) {
                      subItem.creationDateFormat = new Date(
                        subItem.creationDate
                      );
                      newItemFilter.sublevel?.push(subItem);
                    }
                    break;
                  case 5: //recientes
                    if (!subItem.isHome && subItem.creationDate != null) {
                      subItem.creationDateFormat = new Date(
                        subItem.creationDate
                      );
                      newItemFilter.sublevel?.push(subItem);
                    }
                    break;
                  default:
                    break;
                }
              }
            }
          });
        } else {
          //no pasa o error por controlar
        }
      });

      if (filterByText) {
        if (newItemFilter.sublevel.length != 0) {
          this.goToProduct(newItemFilter);
        } else {
          this.showMessageDialog(
            'Advertencia',
            'No se encontraron coincidencias en la búsqueda.',
            'Aceptar',
            '',
            true,
            2,
            this.matDialog,
            (_: any) => {}
          );
        }
      } else {
        if (this.selectedFilter == 3) {
          //ordenar compartidos por cantidad y luego por titulo
          newItemFilter.sublevel.sort((a, b) => {
            if (b.sharedCount === a.sharedCount) {
              return a.title.localeCompare(b.title);
            }
            return b.sharedCount - a.sharedCount;
          });
        } else if (this.selectedFilter == 4 || this.selectedFilter == 5) {
          //ordenar recientes y sugeridos por fecha
          newItemFilter.sublevel.sort(
            (a, b) =>
              b.creationDateFormat.getTime() - a.creationDateFormat.getTime()
          );
        }
        this.goToProduct(newItemFilter);
      }
    }
  }

  get visibleFiltros() {
    return this.filtrosData.filter((item) => item.show);
  }
  get iconFavorite(): string {
    return this.showFavorites ? 'favorite_on' : 'favorite_off';
  }

  goToProduct(p: Product, currentSubmodule?: string) {
    console.log(
      'Ingresar a producto',
      p,
      'CurrentSubmodule:',
      currentSubmodule
    );

    // **DIFERENCIAR ENTRE SUBMODULO E ITEM**
    const esSubmodulo =
      (p.sublevel !== null || Array.isArray(p.sublevel)) && p.level;
    const esItem = !esSubmodulo && !p.isHome;

    console.log(
      'Tipo:',
      esSubmodulo ? 'SUB MODULO' : esItem ? 'ITEM' : 'HOME/REDIRECT'
    );

    // **SOLO HACER TRACKING SI ES UN ITEM**
    if (esItem) {
      const normalizeCompare = (text?: string): string =>
        text
          ? text
              .trim()
              .toUpperCase()
              .normalize('NFD')
              .replace(/[\u0300-\u036f]/g, '')
              .replace(/Ñ/g, 'N')
              .replace(/\s+/g, ' ')
          : '';

      // --- Grupos sin arrays hardcodeados ---
      const grupos = [
        {
          module: 'Portafolio de soluciones',
          category: 'Venta empresas',
          submodule: 'Material de estudio modelo B2B',
          idIngreso: 'PS_MATERIAL_EST_INGRESAR_MATERIAL',
        },
        {
          module: 'Portafolio de soluciones',
          category: 'Venta empresas',
          submodule: 'Preparación y mentalidad',
          idIngreso: 'PS_PREPARACION_INGRESAR_MATERIAL',
        },
        {
          module: 'Portafolio de soluciones',
          category: 'Venta empresas',
          submodule: 'Lograr la reunión',
          idIngreso: 'PS_LOGRAR_REU_INGRESAR_MATERIAL',
        },
        {
          module: 'Portafolio de soluciones',
          category: 'Venta empresas',
          submodule: 'Conectar',
          idIngreso: 'PS_CONECTAR_INGRESAR_MATERIAL',
        },
        {
          module: 'Portafolio de soluciones',
          category: 'Venta empresas',
          submodule: 'Descubrir',
          idIngreso: 'PS_DESCUBRIR_INGRESAR_MATERIAL',
        },
        {
          module: 'Portafolio de soluciones',
          category: 'Venta empresas',
          submodule: 'Impactar',
          idIngreso: 'PS_IMPACTAR_INGRESAR_MATERIAL',
        },
        {
          module: 'Portafolio de soluciones',
          category: 'Venta empresas',
          submodule: 'Presentar',
          idIngreso: 'PS_PRESENTAR_INGRESAR_MATERIAL',
        },
        {
          module: 'Portafolio de soluciones',
          category: 'Venta empresas',
          submodule: 'Ganar',
          idIngreso: 'PS_GANAR_INGRESAR_MATERIAL',
        },
        {
          module: 'Portafolio de soluciones',
          category: 'Venta individual',
          submodule: 'Prospecto',
          idIngreso: 'PS_PROSPECTO_INGRESO_MATERIAL',
        },
        {
          module: 'Portafolio de soluciones',
          category: 'Venta individual',
          submodule: 'Prospecto interesado',
          idIngreso: 'PS_PROSPE_INTER_INGRESAR_MATERIAL',
        },
        {
          module: 'Portafolio de soluciones',
          category: 'Venta individual',
          submodule: 'Visita comercial y presentación de soluciones',
          idIngreso: 'PS_VISITA_COMERCIAL_PRESEN_INGRESAR_MATERIAL',
        },
        {
          module: 'Portafolio de soluciones',
          category: 'Venta individual',
          submodule: 'Fidelización',
          idIngreso: 'PS_FIDELIZACION_INGRESAR_MATERIAL',
        },
        {
          module: 'Portafolio de soluciones',
          category: 'Venta individual',
          submodule: 'Cierre de venta y vinculación',
          idIngreso: 'PS_CIERRE_VENTA_VINCULA_INGRESAR_MATERIAL',
        },
        {
          module: 'Portafolio de soluciones',
          category: 'Venta individual',
          submodule: 'Cliente no interesado',
          idIngreso: 'PS_CLIENTE_NOINTER_INGRESAR_MATERIAL',
        },
        {
          module: 'Portafolio de soluciones',
          category: 'Venta individual',
          submodule: 'Envío de cotización',
          idIngreso: 'PS_ENVIO_COTIZACION_INGRESAR_MATERIAL',
        },
        {
          module: 'Portafolio de soluciones',
          category: 'Venta individual',
          submodule: 'Seguimiento',
          idIngreso: 'PS_SEGUIMIENTO_INGRESAR_MATERIAL',
        },
        {
          module: 'Portafolio de soluciones',
          category: 'Más recursos comerciales',
          submodule: 'Canales de atención',
          idIngreso: 'PS_CANALES_ATENCION_INGRESAR_MATERIAL',
        },
        {
          module: 'Portafolio de soluciones',
          category: 'Más recursos comerciales',
          submodule: 'Promociones',
          idIngreso: 'PS_PROMO_INGRESAR_MATERIAL',
        },
        {
          module: 'Portafolio de soluciones',
          category: 'Más recursos comerciales',
          submodule: 'Centros médicos',
          idIngreso: 'PS_CENTROS_MEDICOS_INGRESAR_MATERIAL',
        },
        {
          module: 'Portafolio de soluciones',
          category: 'Más recursos comerciales',
          submodule: 'Producto',
          idIngreso: 'PS_PRODUCTO_INGRESAR_MATERIAL',
        },
        {
          module: 'Portafolio de soluciones',
          category: 'Más recursos comerciales',
          submodule: 'Cuidado senior',
          idIngreso: 'PS_CUIDADO_SENIOR_INGRESAR_MATERIAL',
        },
        {
          module: 'Portafolio de soluciones',
          category: 'Más recursos comerciales',
          submodule: 'Cuidados de la salud',
          idIngreso: 'PS_CUIDADOS_SALUD_INGRESAR_MATERIAL',
        },
        {
          module: 'Portafolio de soluciones',
          category: 'Más recursos comerciales',
          submodule: 'Sorteos grupo coomeva 2025',
          idIngreso: 'PS_SORTEOS_GRUPOCOO2025_INGRESAR_MATERIAL',
        },
        {
          module: 'Portafolio de soluciones',
          category: 'Más recursos comerciales',
          submodule: 'Débito automático',
          idIngreso: 'PS_DEBITO_AUTOMATICO_INGRESAR_MATERIAL',
        },
        {
          module: 'Portafolio de soluciones',
          category: 'Más recursos comerciales',
          submodule: 'Redes sociales',
          idIngreso: 'PS_REDES_SOCIALES_INGRESAR_MATERIAL',
        },
        {
          module: 'Portafolio de soluciones',
          category: 'Más recursos comerciales',
          submodule: 'Alianzas',
          idIngreso: 'PS_ALIANZAS_INGRESAR_MATERIAL',
        },
        {
          module: 'Portafolio de soluciones',
          category: 'Más recursos comerciales',
          submodule: 'Referidos',
          idIngreso: 'PS_REFERIDOS_INGRESAR_MATERIAL',
        },
        {
          module: 'Portafolio de soluciones',
          category: 'Más recursos comerciales',
          submodule: 'Cuidarte es quererte',
          idIngreso: 'PS_CUIDARTE_ES_QUERERTE_INGRESAR_MATERIAL',
        },
        {
          module: 'Portafolio de soluciones',
          category: 'Más recursos comerciales',
          submodule: 'Nuevas plantillas para presentación',
          idIngreso: 'PS_NUEVAS_PLANTILLAS_INGRESAR_MATERIAL',
        },
        {
          module: 'Portafolio de soluciones',
          category: 'Más recursos comerciales',
          submodule: 'Otros recursos B2B',
          idIngreso: 'PS_OTROS_RECURSO_B2B_INGRESAR_MATERIAL',
        },
        {
          module: 'Portafolio de soluciones',
          category: 'Más recursos comerciales',
          submodule: 'Material empresarial salud oral',
          idIngreso: 'PS_MATERIAL_EMPRESARIAL_SAO_INGRESAR_MATERIAL',
        },
        {
          module: 'Portafolio de soluciones',
          category: 'Más recursos comerciales',
          submodule: 'Material individual salud oral',
          idIngreso: 'PS_MATERIAL_INDIVIDUAL_SAO_INGRESAR_MATERIAL',
        },
      ];

      let grupoTracking = null;

      // 1. PRIMERO usar el currentSubmodule si está disponible
      if (currentSubmodule) {
        const currentNorm = normalizeCompare(currentSubmodule);
        grupoTracking = grupos.find(
          (g) => normalizeCompare(g.submodule) === currentNorm
        );
        console.log(
          `🔍 Buscando en currentSubmodule: "${currentSubmodule}"`,
          grupoTracking ? '✅ Encontrado' : '❌ No encontrado'
        );
      }

      // 2. SI NO, usar el contexto actual del componente
      if (!grupoTracking && this.currentSubmodule) {
        const currentNorm = normalizeCompare(this.currentSubmodule);
        grupoTracking = grupos.find(
          (g) => normalizeCompare(g.submodule) === currentNorm
        );
        console.log(
          `🔍 Buscando en this.currentSubmodule: "${this.currentSubmodule}"`,
          grupoTracking ? '✅ Encontrado' : '❌ No encontrado'
        );
      }

      // 3. SI ENCONTRÓ UN GRUPO, hacer el tracking
      if (grupoTracking) {
        console.log(
          `✅ INGRESAR MATERIAL - Tracking "${grupoTracking.submodule}" para item:`,
          p.title
        );

        this.trackingService
          .trackEvent({
            module: grupoTracking.module,
            category: grupoTracking.category,
            submodule: grupoTracking.submodule,
            functionality: 'Ingresar a material',
            cedulaAsesor: this.cedulaAsesor,
            fechaInteraccion: this.getCurrentTimestamp(),
            nombreAsesor: this.nombreAsesor,
            identificadorInteraccion: grupoTracking.idIngreso,
          })
          .subscribe();
      } else {
        console.log(
          '❌ No se encontró grupo de tracking para el submodule actual'
        );
      }
    } else if (esSubmodulo) {
      console.log(
        '🔶 NAVEGACIÓN - Accediendo a submodulo:',
        p.title,
        ' - Sin tracking'
      );
    } else {
      console.log('🔶 NAVEGACIÓN - Acceso a home/redirect - Sin tracking');
    }

    // Continuar con la lógica de navegación (siempre se ejecuta)
    this.continueWithYourExistingLogic(p);
  }

  private continueWithYourExistingLogic(p: Product) {
    this.backToCatalog(2);
    if ((p.sublevel !== null || Array.isArray(p.sublevel)) && p.level) {
      // ES UN SUBMODULO (categoría con hijos)
      this.isSublevelWithDescription = p.isLevelWithDescription;
      this.onResize();
      this.isSublevel = true;
      this.productSelectedData = p;
      this.productSublevelsData = p.sublevel;
      this.htmlContent = this.sanitizer.bypassSecurityTrustHtml(
        this.productSelectedData.description
      );

      // **IMPORTANTE: Establece el submodule actual cuando entres a un subnivel**
      this.currentSubmodule = p.title;
    } else if (p.isHome && p.redirect != null) {
      // ES UN ITEM DE HOME CON REDIRECCIÓN
      this.router.navigateByUrl(p.redirect);
    } else {
      // ES UN ITEM (detalle de material)
      this.scrollService.hideScroll(false);
      this.isDetail = true;
      this.productSelectedData = p;
      this.detailRouteList = this.originalDataList.flatMap((node) =>
        this.findParents(node, p.index)
      );
    }
  }

  backToCatalog(opt: number) {
    if (opt == 3) {
      this.selectedFilter = 0;
      this.showFavorites = false;
      this.searchText = '';
    }
    opt == 1 ? this.mainCmp.setTitle('HOME') : null;
    this.isDetail = false;
    this.isSublevel = false;
    this.searchText = '';
    this.productSelectedData = new Product();
    this.detailRouteList = [];
    this.isSublevelWithDescription = false;
    this.filterShowList = this.originalDataList;
    this.scrollService.hideScroll(true);
  }

  actionToExecute(opt: number, data: Product, currentSubmodule?: string) {
    console.log(
      'accion a ejecutar',
      opt,
      data,
      'CurrentSubmodule:',
      currentSubmodule
    );
    switch (opt) {
      case 1: //share
        this.downloadFile(data, 1, currentSubmodule); // ← pasar currentSubmodule
        this.openEmailClient(data);
        break;
      case 2: //whats
        this.downloadFile(data, 2, currentSubmodule); // ← pasar currentSubmodule
        const message = encodeURIComponent(data.textToShare);
        const url = `https://wa.me/?text=${message}`;
        window.open(url, '_blank', 'noopener,noreferrer');
        break;
      case 3: //download
        this.downloadFile(data, 3, currentSubmodule); // ← pasar currentSubmodule
        break;
      default:
        break;
    }
  }

  openEmailClient(data: Product): void {
    const recipient = 'example@example.com';
    //const subject = encodeURIComponent('Asunto del Correo');
    const body = encodeURIComponent(data.textToShare);
    const mailtoUrl = `mailto:${recipient}?body=${body}`;
    window.open(mailtoUrl, '_blank', 'noopener,noreferrer');
  }

  downloadFile(data: Product, action: number, currentSubmodule?: string) {
    console.log(
      'descargar archivo',
      data,
      action,
      'CurrentSubmodule:',
      currentSubmodule
    );

    const cedulaAsesor =
      this.logInfo.document.split('. ')[1] || this.logInfo.document;
    const nombreAsesor = `${this.logInfo.nombre.trim()} ${this.logInfo.primerApellido.trim()} ${this.logInfo.segundoApellido.trim()}`;

    console.log('cedulaAsesor', cedulaAsesor);
    console.log('nombreAsesor', nombreAsesor);

    const normalizeCompare = (text?: string): string =>
      text
        ? text
            .trim()
            .toUpperCase()
            .normalize('NFD')
            .replace(/[\u0300-\u036f]/g, '')
            .replace(/Ñ/g, 'N')
            .replace(/\s+/g, ' ')
        : '';

    // --- Grupos sin arrays hardcodeados ---
    const grupos = [
      {
        module: 'Portafolio de soluciones',
        category: 'Venta empresas',
        submodule: 'Material de estudio modelo B2B',
        ids: {
          correo: 'PS_MATERIAL_EST_COMPARTIR_CORREO',
          whatsapp: 'PS_MATERIAL_EST_COMPARTIR_WHATSAPP',
          descargar: 'PS_MATERIAL_EST_DESCARGAR',
        },
      },
      {
        module: 'Portafolio de soluciones',
        category: 'Venta empresas',
        submodule: 'Preparación y mentalidad',
        ids: {
          correo: 'PS_PREPARACION_COMPARTIR_CORREO',
          whatsapp: 'PS_PREPARACION_COMPARTIR_WHATSAPP',
          descargar: 'PS_PREPARACION_DESCARGAR',
        },
      },
      {
        module: 'Portafolio de soluciones',
        category: 'Venta empresas',
        submodule: 'Lograr la reunión',
        ids: {
          correo: 'PS_LOGRAR_REU_COMPARTIR_CORREO',
          whatsapp: 'PS_LOGRAR_REU_COMPARTIR_WHATSAPP',
          descargar: 'PS_LOGRAR_REU_DESCARGAR',
        },
      },
      {
        module: 'Portafolio de soluciones',
        category: 'Venta empresas',
        submodule: 'Conectar',
        ids: {
          correo: 'PS_CONECTAR_COMPARTIR_CORREO',
          whatsapp: 'PS_CONECTAR_COMPARTIR_WHATSAPP',
          descargar: 'PS_CONECTAR_DESCARGAR',
        },
      },
      {
        module: 'Portafolio de soluciones',
        category: 'Venta empresas',
        submodule: 'Descubrir',
        ids: {
          correo: 'PS_DESCUBRIR_COMPARTIR_CORREO',
          whatsapp: 'PS_DESCUBRIR_COMPARTIR_WHATSAPP',
          descargar: 'PS_DESCUBRIR_DESCARGAR',
        },
      },
      {
        module: 'Portafolio de soluciones',
        category: 'Venta empresas',
        submodule: 'Impactar',
        ids: {
          correo: 'PS_IMPACTAR_COMPARTIR_CORREO',
          whatsapp: 'PS_IMPACTAR_COMPARTIR_WHATSAPP',
          descargar: 'PS_IMPACTAR_DESCARGAR',
        },
      },
      {
        module: 'Portafolio de soluciones',
        category: 'Venta empresas',
        submodule: 'Presentar',
        ids: {
          correo: 'PS_PRESENTAR_COMPARTIR_CORREO',
          whatsapp: 'PS_PRESENTAR_COMPARTIR_WHATSAPP',
          descargar: 'PS_PRESENTAR_DESCARGAR',
        },
      },
      {
        module: 'Portafolio de soluciones',
        category: 'Venta empresas',
        submodule: 'Ganar',
        ids: {
          correo: 'PS_GANAR_COMPARTIR_CORREO',
          whatsapp: 'PS_GANAR_COMPARTIR_WHATSAPP',
          descargar: 'PS_GANAR_DESCARGAR',
        },
      },
      {
        module: 'Portafolio de soluciones',
        category: 'Venta individual',
        submodule: 'Prospecto',
        ids: {
          correo: 'PS_PROSPECTO_COMPARTIR_CORREO',
          whatsapp: 'PS_PROSPECTO_COMPARTIR_WHATSAPP',
          descargar: 'PS_PROSPECTO_DESCARGAR',
        },
      },
      {
        module: 'Portafolio de soluciones',
        category: 'Venta individual',
        submodule: 'Prospecto interesado',
        ids: {
          correo: 'PS_PROSPE_INTER_COMPARTIR_CORREO',
          whatsapp: 'PS_PROSPE_INTER_COMPARTIR_WHATSAPP',
          descargar: 'PS_PROSPE_INTER_DESCARGAR',
        },
      },
      {
        module: 'Portafolio de soluciones',
        category: 'Venta individual',
        submodule: 'Visita comercial y presentación de soluciones',
        ids: {
          correo: 'PS_VISITA_COMERCIAL_PRESEN_COMPARTIR_CORREO',
          whatsapp: 'PS_VISITA_COMERCIAL_PRESEN_COMPARTIR_WHATSAPP',
          descargar: 'PS_VISITA_COMERCIAL_PRESEN_DESCARGAR',
        },
      },
      {
        module: 'Portafolio de soluciones',
        category: 'Venta individual',
        submodule: 'Fidelización',
        ids: {
          correo: 'PS_FIDELIZACION_COMPARTIR_CORREO',
          whatsapp: 'PS_FIDELIZACION_COMPARTIR_WHATSAPP',
          descargar: 'PS_FIDELIZACION_DESCARGAR',
        },
      },
      {
        module: 'Portafolio de soluciones',
        category: 'Venta individual',
        submodule: 'Cierre de venta y vinculación',
        ids: {
          correo: 'PS_CIERRE_VENTA_VINCULA_COMPARTIR_CORREO',
          whatsapp: 'PS_CIERRE_VENTA_VINCULA_COMPARTIR_WHATSAPP',
          descargar: 'PS_CIERRE_VENTA_VINCULA_DESCARGAR',
        },
      },
      {
        module: 'Portafolio de soluciones',
        category: 'Venta individual',
        submodule: 'Cliente no interesado',
        ids: {
          correo: 'PS_CLIENTE_NOINTER_COMPARTIR_CORREO',
          whatsapp: 'PS_CLIENTE_NOINTER_COMPARTIR_WHATSAPP',
          descargar: 'PS_CLIENTE_NOINTER_DESCARGAR',
        },
      },
      {
        module: 'Portafolio de soluciones',
        category: 'Venta individual',
        submodule: 'Envío de cotización',
        ids: {
          correo: 'PS_ENVIO_COTIZACION_COMPARTIR_CORREO',
          whatsapp: 'PS_ENVIO_COTIZACION_COMPARTIR_WHATSAPP',
          descargar: 'PS_ENVIO_COTIZACION_DESCARGAR',
        },
      },
      {
        module: 'Portafolio de soluciones',
        category: 'Venta individual',
        submodule: 'Seguimiento',
        ids: {
          correo: 'PS_SEGUIMIENTO_COMPARTIR_CORREO',
          whatsapp: 'PS_SEGUIMIENTO_COMPARTIR_WHATSAPP',
          descargar: 'PS_SEGUIMIENTO_DESCARGAR',
        },
      },
      {
        module: 'Portafolio de soluciones',
        category: 'Más recursos comerciales',
        submodule: 'Canales de atención',
        ids: {
          correo: 'PS_CANALES_ATENCION_COMPARTIR_CORREO',
          whatsapp: 'PS_CANALES_ATENCION_COMPARTIR_WHATSAPP',
          descargar: 'PS_CANALES_ATENCION_DESCARGAR',
        },
      },
      {
        module: 'Portafolio de soluciones',
        category: 'Más recursos comerciales',
        submodule: 'Promociones',
        ids: {
          correo: 'PS_PROMO_COMPARTIR_CORREO',
          whatsapp: 'PS_PROMO_COMPARTIR_WHATSAPP',
          descargar: 'PS_PROMO_DESCARGAR',
        },
      },
      {
        module: 'Portafolio de soluciones',
        category: 'Más recursos comerciales',
        submodule: 'Centros médicos',
        ids: {
          correo: 'PS_CENTROS_MEDICOS_COMPARTIR_CORREO',
          whatsapp: 'PS_CENTROS_MEDICOS_COMPARTIR_WHATSAPP',
          descargar: 'PS_CENTROS_MEDICOS_DESCARGAR',
        },
      },
      {
        module: 'Portafolio de soluciones',
        category: 'Más recursos comerciales',
        submodule: 'Producto',
        ids: {
          correo: 'PS_PRODUCTO_COMPARTIR_CORREO',
          whatsapp: 'PS_PRODUCTO_COMPARTIR_WHATSAPP',
          descargar: 'PS_PRODUCTO_DESCARGAR',
        },
      },
      {
        module: 'Portafolio de soluciones',
        category: 'Más recursos comerciales',
        submodule: 'Cuidado senior',
        ids: {
          correo: 'PS_CUIDADO_SENIOR_COMPARTIR_CORREO',
          whatsapp: 'PS_CUIDADO_SENIOR_COMPARTIR_WHATSAPP',
          descargar: 'PS_CUIDADO_SENIOR_DESCARGAR',
        },
      },
      {
        module: 'Portafolio de soluciones',
        category: 'Más recursos comerciales',
        submodule: 'Cuidados de la salud',
        ids: {
          correo: 'PS_CUIDADOS_SALUD_COMPARTIR_CORREO',
          whatsapp: 'PS_CUIDADOS_SALUD_COMPARTIR_WHATSAPP',
          descargar: 'PS_CUIDADOS_SALUD_DESCARGAR',
        },
      },
      {
        module: 'Portafolio de soluciones',
        category: 'Más recursos comerciales',
        submodule: 'Sorteos grupo coomeva 2025',
        ids: {
          correo: 'PS_SORTEOS_GRUPOCOO2025_COMPARTIR_CORREO',
          whatsapp: 'PS_SORTEOS_GRUPOCOO2025_COMPARTIR_WHATSAPP',
          descargar: 'PS_SORTEOS_GRUPOCOO2025_DESCARGAR',
        },
      },
      {
        module: 'Portafolio de soluciones',
        category: 'Más recursos comerciales',
        submodule: 'Débito automático',
        ids: {
          correo: 'PS_DEBITO_AUTOMATICO_COMPARTIR_CORREO',
          whatsapp: 'PS_DEBITO_AUTOMATICO_COMPARTIR_WHATSAPP',
          descargar: 'PS_DEBITO_AUTOMATICO_DESCARGAR',
        },
      },
      {
        module: 'Portafolio de soluciones',
        category: 'Más recursos comerciales',
        submodule: 'Redes sociales',
        ids: {
          correo: 'PS_REDES_SOCIALES_COMPARTIR_CORREO',
          whatsapp: 'PS_REDES_SOCIALES_COMPARTIR_WHATSAPP',
          descargar: 'PS_REDES_SOCIALES_DESCARGAR',
        },
      },
      {
        module: 'Portafolio de soluciones',
        category: 'Más recursos comerciales',
        submodule: 'Alianzas',
        ids: {
          correo: 'PS_ALIANZAS_COMPARTIR_CORREO',
          whatsapp: 'PS_ALIANZAS_COMPARTIR_WHATSAPP',
          descargar: 'PS_ALIANZAS_DESCARGAR',
        },
      },
      {
        module: 'Portafolio de soluciones',
        category: 'Más recursos comerciales',
        submodule: 'Referidos',
        ids: {
          correo: 'PS_REFERIDOS_COMPARTIR_CORREO',
          whatsapp: 'PS_REFERIDOS_COMPARTIR_WHATSAPP',
          descargar: 'PS_REFERIDOS_DESCARGAR',
        },
      },
      {
        module: 'Portafolio de soluciones',
        category: 'Más recursos comerciales',
        submodule: 'Cuidarte es quererte',
        ids: {
          correo: 'PS_CUIDARTE_ES_QUERERTE_COMPARTIR_CORREO',
          whatsapp: 'PS_CUIDARTE_ES_QUERERTE_COMPARTIR_WHATSAPP',
          descargar: 'PS_CUIDARTE_ES_QUERERTE_DESCARGAR',
        },
      },
      {
        module: 'Portafolio de soluciones',
        category: 'Más recursos comerciales',
        submodule: 'Nuevas plantillas para presentación',
        ids: {
          correo: 'PS_NUEVAS_PLANTILLAS_COMPARTIR_CORREO',
          whatsapp: 'PS_NUEVAS_PLANTILLAS_COMPARTIR_WHATSAPP',
          descargar: 'PS_NUEVAS_PLANTILLAS_DESCARGAR',
        },
      },
      {
        module: 'Portafolio de soluciones',
        category: 'Más recursos comerciales',
        submodule: 'Otros recursos B2B',
        ids: {
          correo: 'PS_OTROS_RECURSO_B2B_COMPARTIR_CORREO',
          whatsapp: 'PS_OTROS_RECURSO_B2B_COMPARTIR_WHATSAPP',
          descargar: 'PS_OTROS_RECURSO_B2B_DESCARGAR',
        },
      },
      {
        module: 'Portafolio de soluciones',
        category: 'Más recursos comerciales',
        submodule: 'Material empresarial salud oral',
        ids: {
          correo: 'PS_MATERIAL_EMPRESARIAL_SAO_COMPARTIR_CORREO',
          whatsapp: 'PS_MATERIAL_EMPRESARIAL_SAO_COMPARTIR_WHATSAPP',
          descargar: 'PS_MATERIAL_EMPRESARIAL_SAO_DESCARGAR',
        },
      },
      {
        module: 'Portafolio de soluciones',
        category: 'Más recursos comerciales',
        submodule: 'Material individual salud oral',
        ids: {
          correo: 'PS_MATERIAL_INDIVIDUAL_SAO_COMPARTIR_CORREO',
          whatsapp: 'PS_MATERIAL_INDIVIDUAL_SAO_COMPARTIR_WHATSAPP',
          descargar: 'PS_MATERIAL_INDIVIDUAL_SAO_DESCARGAR',
        },
      },
    ];

    let grupoTracking = null;

    // 1. PRIMERO usar el currentSubmodule si está disponible
    if (currentSubmodule) {
      const currentNorm = normalizeCompare(currentSubmodule);
      grupoTracking = grupos.find(
        (g) => normalizeCompare(g.submodule) === currentNorm
      );
      console.log(
        `🔍 Buscando en currentSubmodule: "${currentSubmodule}"`,
        grupoTracking ? '✅ Encontrado' : '❌ No encontrado'
      );
    }

    // 2. SI NO, usar el contexto actual del componente
    if (!grupoTracking && this.currentSubmodule) {
      const currentNorm = normalizeCompare(this.currentSubmodule);
      grupoTracking = grupos.find(
        (g) => normalizeCompare(g.submodule) === currentNorm
      );
      console.log(
        `🔍 Buscando en this.currentSubmodule: "${this.currentSubmodule}"`,
        grupoTracking ? '✅ Encontrado' : '❌ No encontrado'
      );
    }

    // 3. SI ENCONTRÓ UN GRUPO, hacer el tracking
    if (grupoTracking) {
      let functionality = '';
      let identificadorInteraccion = '';

      if (action === 1) {
        functionality = 'Compartir vía correo electrónico';
        identificadorInteraccion = grupoTracking.ids.correo;
      } else if (action === 2) {
        functionality = 'Compartir vía WhatsApp';
        identificadorInteraccion = grupoTracking.ids.whatsapp;
      } else if (action === 3) {
        functionality = 'Descargar';
        identificadorInteraccion = grupoTracking.ids.descargar;
      }

      console.log(
        `✅ ACCIÓN - Tracking "${grupoTracking.submodule}" para:`,
        data.title,
        'Acción:',
        functionality
      );

      this.trackingService
        .trackEvent({
          module: grupoTracking.module,
          category: grupoTracking.category,
          submodule: grupoTracking.submodule,
          functionality,
          cedulaAsesor,
          fechaInteraccion: this.getCurrentTimestamp(),
          nombreAsesor,
          identificadorInteraccion,
        })
        .subscribe();
    } else {
      console.log(
        '❌ No se encontró grupo de tracking para el submodule actual'
      );
    }

    // Continuar con la lógica de descarga/compartir
    if (data.fileUrl != null) {
      data.isDownloading = true;
      this.downloadService.downloadFile(data.fileUrl).subscribe(
        (blob) => {
          const link = document.createElement('a');
          const objectUrl = URL.createObjectURL(blob);
          let filename = this.getFilenameFromUrl(data.fileUrl);
          if (!filename.includes('.')) {
            const fileType = blob.type;
            if (fileType.includes('image')) {
              filename += '.png';
            } else if (fileType.includes('pdf')) {
              filename += '.pdf';
            } else if (fileType.includes('video')) {
              filename += '.mp4';
            } else {
              filename += '.file';
            }
          }
          link.href = objectUrl;
          link.download = filename;
          document.body.appendChild(link);
          link.click();
          URL.revokeObjectURL(objectUrl);
          document.body.removeChild(link);
          this.downloadCount(data.id, action);
          data.isDownloading = false;
        },
        (error) => {
          data.isDownloading = false;
          console.error('Error al descargar el archivo:', error);
        }
      );
    } else {
      this.showMessageDialog(
        'Error',
        'No se puede obtener la url del recurso.',
        'Aceptar',
        '',
        true,
        1,
        this.matDialog,
        (_: any) => {}
      );
    }
  }

  getFilenameFromUrl(url: string): string {
    return url.substring(url.lastIndexOf('/') + 1);
  }

  getPortafolioData() {
    this.spinner.show();
    const userCC: UserLoggedResponse =
      this.storageService.getItem('user') ?? 'Document no esta llegando';
    const role: UserRolResponde[] = userCC.roles;
    this.portafolioService
      .getPortafolioData(
        this.loggedUser.document.slice(4),
        role[0].claveRol == 'Ova_AseInter' ? 'INTERNO' : 'EXTERNO'
      )
      .subscribe({
        next: (response) => {
          this.spinner.hide();
          if (response.status) {
            this.originalDataList = response.data;

            this.jsonDataPoblacion.forEach((item) => {
              //se añade quemado los datos de poblacion
              this.originalDataList.push(item);
            });

            this.scrollService.hideScroll(true);
            this.filterShowList = this.originalDataList;
            this.onSelectFilter(this.filtrosData[0]); //carga inicio
          } else {
            this.showMessageDialog(
              'Error',
              'Error en obtener la data inicial.',
              'Aceptar',
              '',
              true,
              1,
              this.matDialog,
              (_: any) => {}
            );
          }
        },
        error: (error) => {
          this.spinner.hide();
          this.showMessageDialog(
            'Error',
            'Error en obtener la data inicial.',
            'Aceptar',
            '',
            true,
            1,
            this.matDialog,
            (_: any) => {
              this.router.navigateByUrl('/');
            }
          );
        },
      });
  }

  updateFavoriteStatus(id: number, opt: boolean, currentSubmodule?: any) {
    console.log('=== DEBUG FAVORITO ===');
    console.log(
      'ID:',
      id,
      'Opt:',
      opt,
      'CurrentSubmodule recibido:',
      currentSubmodule
    );
    console.log('isSublevel:', this.isSublevel, 'isDetail:', this.isDetail);
    console.log('productSelectedData:', this.productSelectedData?.title);

    if (this.isSublevel && this.productSelectedData) {
      console.log('En sublevel, título:', this.productSelectedData.title);
    }

    this.spinner.show();
    const data = {
      user: this.loggedUser.document.slice(4),
      status: opt,
      id: id,
    };

    // 🔹 Normalizamos el submódulo antes de pasarlo
    const normalizar = (texto: string) =>
      texto
        ? texto
            .trim()
            .toUpperCase()
            .normalize('NFD')
            .replace(/[\u0300-\u036f]/g, '')
            .replace(/Ñ/g, 'N')
        : '';

    const currentSubmoduleNormalizado = normalizar(currentSubmodule);

    this.portafolioService.saveFavorite(data).subscribe({
      next: (response) => {
        this.spinner.hide();
        if (response.status) {
          console.log(
            'Llamando actualizarEstadoFavorite con submodule normalizado:',
            currentSubmoduleNormalizado
          );
          this.actualizarEstadoFavorite(
            this.filterShowList,
            id,
            opt,
            currentSubmoduleNormalizado
          );
        } else {
          this.showMessageDialog(
            'Error',
            'Error al actualizar favoritos.',
            'Aceptar',
            '',
            true,
            1,
            this.matDialog,
            (_: any) => {}
          );
        }
      },
      error: (error) => {
        this.spinner.hide();
        this.showMessageDialog(
          'Error',
          'Error al actualizar favoritos.',
          'Aceptar',
          '',
          true,
          1,
          this.matDialog,
          (_: any) => {
            this.router.navigateByUrl('/');
          }
        );
      },
    });
  }

  actualizarEstadoFavorite(
    array: Product[],
    id: number,
    opcion: boolean,
    currentSubmodule?: string,
    procesados: Set<string> = new Set<string>()
  ): boolean {
    if (!procesados) {
      procesados = new Set<string>();
    }

    console.log('=== DEBUG ACTUALIZAR FAVORITO ===');
    console.log(
      'CurrentSubmodule recibido en actualizarEstadoFavorite:',
      currentSubmodule
    );

    const normalizeCompare = (text?: string): string =>
      text
        ? text
            .trim()
            .toUpperCase()
            .normalize('NFD')
            .replace(/[\u0300-\u036f]/g, '')
            .replace(/Ñ/g, 'N')
            .replace(/\s+/g, ' ')
        : '';

    // --- Grupos sin el parámetro arr ---
    const grupos = [
      {
        module: 'Portafolio de soluciones',
        category: 'Venta empresas',
        submodule: 'Material de estudio modelo B2B',
        identificador: 'PS_MATERIAL_B2B_MARCAR_FAVORITO',
      },
      {
        module: 'Portafolio de soluciones',
        category: 'Venta empresas',
        submodule: 'Preparación y mentalidad',
        identificador: 'PS_PREPARACION_MARCAR_FAVORITO',
      },
      {
        module: 'Portafolio de soluciones',
        category: 'Venta empresas',
        submodule: 'Lograr la reunión',
        identificador: 'PS_LOGRAR_REU_MARCAR_FAVORITO',
      },
      {
        module: 'Portafolio de soluciones',
        category: 'Venta empresas',
        submodule: 'Conectar',
        identificador: 'PS_CONECTAR_MARCAR_FAVORITO',
      },
      {
        module: 'Portafolio de soluciones',
        category: 'Venta empresas',
        submodule: 'Descubrir',
        identificador: 'PS_DESCUBRIR_MARCAR_FAVORITO',
      },
      {
        module: 'Portafolio de soluciones',
        category: 'Venta empresas',
        submodule: 'Impactar',
        identificador: 'PS_IMPACTAR_MARCAR_FAVORITO',
      },
      {
        module: 'Portafolio de soluciones',
        category: 'Venta empresas',
        submodule: 'Presentar',
        identificador: 'PS_PRESENTAR_MARCAR_FAVORITO',
      },
      {
        module: 'Portafolio de soluciones',
        category: 'Venta empresas',
        submodule: 'Ganar',
        identificador: 'PS_GANAR_MARCAR_FAVORITO',
      },
      {
        module: 'Portafolio de soluciones',
        category: 'Venta individual',
        submodule: 'Prospecto',
        identificador: 'PS_PROSPECTO_MARCAR_FAVORITO',
      },
      {
        module: 'Portafolio de soluciones',
        category: 'Venta individual',
        submodule: 'Prospecto interesado',
        identificador: 'PS_PROSPECTO_INTER_MARCAR_FAVORITO',
      },
      {
        module: 'Portafolio de soluciones',
        category: 'Venta individual',
        submodule: 'Visita comercial y presentación de soluciones',
        identificador: 'PS_VISITA_COMERCIAL_PRESEN_MARCAR_FAVORITO',
      },
      {
        module: 'Portafolio de soluciones',
        category: 'Venta individual',
        submodule: 'Fidelización',
        identificador: 'PS_FIDELIZACION_MARCAR_FAVORITO',
      },
      {
        module: 'Portafolio de soluciones',
        category: 'Venta individual',
        submodule: 'Cierre de venta y vinculación',
        identificador: 'PS_CIERRE_VENTA_VINCULA_MARCAR_FAVORITO',
      },
      {
        module: 'Portafolio de soluciones',
        category: 'Venta individual',
        submodule: 'Cliente no interesado',
        identificador: 'PS_CLIENTE_NOINTER_MARCAR_FAVORITO',
      },
      {
        module: 'Portafolio de soluciones',
        category: 'Venta individual',
        submodule: 'Envío de cotización',
        identificador: 'PS_ENVIO_COTIZACION_MARCAR_FAVORITO',
      },
      {
        module: 'Portafolio de soluciones',
        category: 'Venta individual',
        submodule: 'Seguimiento',
        identificador: 'PS_SEGUIMIENTO_MARCAR_FAVORITO',
      },
      {
        module: 'Portafolio de soluciones',
        category: 'Más recursos comerciales',
        submodule: 'Canales de atención',
        identificador: 'PS_CANALES_ATENCION_MARCAR_FAVORITO',
      },
      {
        module: 'Portafolio de soluciones',
        category: 'Más recursos comerciales',
        submodule: 'Promociones',
        identificador: 'PS_PROMO_MARCAR_FAVORITO',
      },
      {
        module: 'Portafolio de soluciones',
        category: 'Más recursos comerciales',
        submodule: 'Centros médicos',
        identificador: 'PS_CENTROS_MEDICOS_MARCAR_FAVORITO',
      },
      {
        module: 'Portafolio de soluciones',
        category: 'Más recursos comerciales',
        submodule: 'Producto',
        identificador: 'PS_PRODUCTO_MARCAR_FAVORITO',
      },
      {
        module: 'Portafolio de soluciones',
        category: 'Más recursos comerciales',
        submodule: 'Cuidado senior',
        identificador: 'PS_CUIDADO_SENIOR_MARCAR_FAVORITO',
      },
      {
        module: 'Portafolio de soluciones',
        category: 'Más recursos comerciales',
        submodule: 'Cuidados de la salud',
        identificador: 'PS_CUIDADOS_SALUD_MARCAR_FAVORITO',
      },
      {
        module: 'Portafolio de soluciones',
        category: 'Más recursos comerciales',
        submodule: 'Sorteos grupo coomeva 2025',
        identificador: 'PS_SORTEOS_GRUPOCOO2025_MARCAR_FAVORITO',
      },
      {
        module: 'Portafolio de soluciones',
        category: 'Más recursos comerciales',
        submodule: 'Débito automático',
        identificador: 'PS_DEBITO_AUTOMATICO_MARCAR_FAVORITO',
      },
      {
        module: 'Portafolio de soluciones',
        category: 'Más recursos comerciales',
        submodule: 'Redes sociales',
        identificador: 'PS_REDES_SOCIALES_MARCAR_FAVORITO',
      },
      {
        module: 'Portafolio de soluciones',
        category: 'Más recursos comerciales',
        submodule: 'Alianzas',
        identificador: 'PS_ALIANZAS_MARCAR_FAVORITO',
      },
      {
        module: 'Portafolio de soluciones',
        category: 'Más recursos comerciales',
        submodule: 'Referidos',
        identificador: 'PS_REFERIDOS_MARCAR_FAVORITO',
      },
      {
        module: 'Portafolio de soluciones',
        category: 'Más recursos comerciales',
        submodule: 'Cuidar es quererte',
        identificador: 'PS_CUIDARTE_ES_QUERERTE_MARCAR_FAVORITO',
      },
      {
        module: 'Portafolio de soluciones',
        category: 'Más recursos comerciales',
        submodule: 'Nuevas plantillas de presentación',
        identificador: 'PS_NUEVAS_PLANTILLAS_MARCAR_FAVORITO',
      },
      {
        module: 'Portafolio de soluciones',
        category: 'Más recursos comerciales',
        submodule: 'Otros recursos B2B',
        identificador: 'PS_OTROS_RECURSO_B2B_MARCAR_FAVORITO',
      },
      {
        module: 'Portafolio de soluciones',
        category: 'Más recursos comerciales',
        submodule: 'Material empresarial salud oral',
        identificador: 'PS_MATERIAL_EMPRESARIAL_SAO_MARCAR_FAVORITO',
      },
      {
        module: 'Portafolio de soluciones',
        category: 'Más recursos comerciales',
        submodule: 'Material individual salud oral',
        identificador: 'PS_MATERIAL_INDIVIDUAL_SAO_MARCAR_FAVORITO',
      },
    ];

    for (const producto of array) {
      if (producto.id === id) {
        if (procesados.has(producto.id.toString())) {
          console.log('Producto ya procesado:', producto.id);
          return true;
        }

        let grupoTracking = null;
        if (currentSubmodule) {
          const currentNorm = normalizeCompare(currentSubmodule);
          grupoTracking = grupos.find(
            (g) => normalizeCompare(g.submodule) === currentNorm
          );
        }

        const displaySubmodule = grupoTracking
          ? grupoTracking.submodule
          : currentSubmodule;

        console.log(
          `✅ FAVORITO - Tracking "${displaySubmodule}" para item id ${producto.id}`
        );
        procesados.add(producto.id.toString());

        this.trackingService
          .trackEvent({
            module: grupoTracking
              ? grupoTracking.module
              : 'Portafolio de soluciones',
            category: grupoTracking
              ? grupoTracking.category
              : 'Más recursos comerciales',
            submodule: displaySubmodule,
            functionality: 'Marcar como favorito',
            cedulaAsesor: this.cedulaAsesor,
            fechaInteraccion: this.getCurrentTimestamp(),
            nombreAsesor: this.nombreAsesor,
            identificadorInteraccion: grupoTracking
              ? grupoTracking.identificador
              : '',
          })
          .subscribe();

        producto.isFavorite = opcion;

        // Actualización de estructuras visibles
        this.filterShowList = this.filterShowList.map((cat) => ({
          ...cat,
          sublevel: cat.sublevel
            ? cat.sublevel.map((s) =>
                s.id === producto.id ? { ...s, isFavorite: opcion } : s
              )
            : cat.sublevel,
        }));

        if (this.productSublevelsData) {
          this.productSublevelsData = this.productSublevelsData.map((s) =>
            s.id === producto.id ? { ...s, isFavorite: opcion } : s
          );
        }

        if (
          this.productSelectedData &&
          this.productSelectedData.id === producto.id
        ) {
          this.productSelectedData = {
            ...this.productSelectedData,
            isFavorite: opcion,
          };
        }

        this.cdr.detectChanges();
        return true;
      }

      // Recursión para subniveles
      if (
        producto.sublevel &&
        this.actualizarEstadoFavorite(
          producto.sublevel,
          id,
          opcion,
          currentSubmodule,
          procesados
        )
      ) {
        return true;
      }
    }

    return false;
  }

  downloadCount(id: number, action: number) {
    this.spinner.show();
    this.portafolioService
      .countDownload(id, this.loggedUser.document.slice(4), action)
      .subscribe({
        //chambonada por que ellos lo retornan asi this.loggedUser.document.slice(4)
        next: (response) => {
          this.spinner.hide();
          if (response.status) {
            //actualizar?
          } else {
            this.showMessageDialog(
              'Advertencia',
              'Error al registrar log de la acción.',
              'Aceptar',
              '',
              true,
              1,
              this.matDialog,
              (_: any) => {}
            );
          }
        },
        error: (error) => {
          this.spinner.hide();
          this.showMessageDialog(
            'Error',
            'Error en el registro del log de la acción.',
            'Aceptar',
            '',
            true,
            1,
            this.matDialog,
            (_: any) => {}
          );
        },
      });
  }

  findParents(
    node: Product,
    targetIndex: string,
    parents: Product[] = []
  ): Product[] {
    if (node.index === targetIndex) {
      return parents;
    }

    if (node.sublevel) {
      for (const child of node.sublevel) {
        const result = this.findParents(child, targetIndex, [...parents, node]);
        if (result.length > 0) {
          return result;
        }
      }
    }
    return [];
  }

  ngOnDestroy() {
    this.scrollService.hideScroll(false);
  }

  private getCurrentTimestamp(): string {
    const fecha = new Date();
    const yyyy = fecha.getFullYear();
    const MM = (fecha.getMonth() + 1).toString().padStart(2, '0');
    const dd = fecha.getDate().toString().padStart(2, '0');
    const HH = fecha.getHours().toString().padStart(2, '0');
    const mm = fecha.getMinutes().toString().padStart(2, '0');
    const ss = fecha.getSeconds().toString().padStart(2, '0');
    return `${yyyy}-${MM}-${dd} ${HH}:${mm}:${ss}`;
  }
}

class Product {
  id: number;
  title: string;
  description: string;
  internalDescription: string;
  whenToUse: string;
  textToShare: string;
  suggestedText: string;
  level: boolean;
  isHome: boolean;
  isLevelWithDescription: boolean;
  redirect: string;
  isFavorite: boolean;
  sublevel: Product[] | null;
  range: string;
  category: number;
  sharedCount: number;
  isSuggested: boolean;
  creationDate: string;
  creationDateFormat: Date;
  bannerURL: string;
  fileUrl: string;
  actions: number[];
  type: string;
  positionImage: string;
  referenceImage: string;
  index: string;
  isDownloading: boolean;

  constructor(product: any = {}) {
    this.id = product.id;
    this.title = product.title;
    this.description = product.description;
    this.internalDescription = product.internalDescription;
    this.whenToUse = product.whenToUse;
    this.textToShare = product.textToShare;
    this.suggestedText = product.suggestedText;
    this.level = product.level;
    this.isHome = product.isHome;
    this.isLevelWithDescription = product.isLevelWithDescription;
    this.redirect = product.redirect;
    this.isFavorite = product.isFavorite;
    this.sublevel = product.sublevel;
    this.range = product.range;
    this.category = product.category;
    this.sharedCount = product.sharedCount;
    this.isSuggested = product.isSuggested;
    this.creationDate = product.creationDate;
    this.creationDateFormat = product.creationDateFormat;
    this.bannerURL = product.bannerURL;
    this.fileUrl = product.fileUrl;
    this.actions = product.actions;
    this.type = product.type;
    this.positionImage = product.positionImage;
    this.referenceImage = product.referenceImage;
    this.index = product.index;
    this.isDownloading = false;
  }
}